import React from "react";
import "./App.css";
import "./Wolfstyle.css";
import { Hexagon, MagnifyingGlass } from "phosphor-react";

const ProductCard = ({game}) => {
    // console.log(game)
    return (
        <div class="lg:col-span-3 md:col-span-6 sm:col-span-6 col-span-12 aos-init aos-animate" data-aos="zoom-in">
        <div class="px-3 py-3 bg-nu7 rounded-2xl hover:bg-nu5 hover:border-2 border-2 border-nu2 duration-500 hover:border-secondary">
            <a href={game.url}>
                <div class="img-box rounded-2xl">
                    <img class="w-full rounded-2xl img" src={game.banner} alt="" loading="lazy"/>
                </div>
            </a>
            <div class="pt-4">
                <a href="game-details.html" class="text-nu1 text-[20px] font-semibold hover:underline">{game.name}</a>
                <p class="text-nu1 pb-3">{game.category}</p>
                <div class="flex justify-between items-center">
                    {/* <div class="flex">
                        <img class="w-[34px] h-[34px]" src="/images/games-card-man1.1.png" alt="" loading="lazy"/>
                        <img class="w-[34px] h-[34px] -ml-[14px]" src="/images/games-card-man1.2.png" alt="" loading="lazy"/>
                        <img class="w-[34px] h-[34px] -ml-[14px]" src="/images/games-card-man1.3.png" alt="" loading="lazy"/>
                        <div>
                            <div class="px-[3px] py-[3px] text-nu1 bg-nu4 rounded-full border-2 -ml-[14px]">
                                +99
                            </div>
                        </div>
                    </div>
                    <a href="game-details.html">
                        <button class="buttonx rounded-full z-10 xl:px-3 px-2 xl:py-2 py-1 flex items-center">
                            <span class="pr-1 pt-1"><i class="text-[18px] ph-bold ph-plus"></i></span>
                            Follow
                        </button>
                    </a> */}
                </div>
            </div>
        </div>
    </div>
    )
}

export default ProductCard